import type { PlanWizardForm } from '~/modules/artist-roster/pages/artist-details/pages/media-planner/types';

export const PLAN_WIZARD_DEFAULT_VALUES: PlanWizardForm = {
  campaignName: '',
  trackId: undefined,
  objectives: [],
  markets: [],
  platforms: [],
  currency: 'USD',
  totalBudget: 0,
};
